import { render, staticRenderFns } from "./ExtensionPageEdit.vue?vue&type=template&id=4822897b&scoped=true"
import script from "./ExtensionPageEdit.vue?vue&type=script&lang=js"
export * from "./ExtensionPageEdit.vue?vue&type=script&lang=js"
import style0 from "./ExtensionPageEdit.vue?vue&type=style&index=0&id=4822897b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4822897b",
  null
  
)

export default component.exports